export const widgetStyles = {
  '.form-control':
    'border-left: none; border-top: none; border-right: none; border-radius: unset; background-color: #f5f5f7; font-family: mBank, Arial, sans-serif; padding: 0.125rem 0.4rem;',
  input: 'font-family: mBank, Arial, sans-serif;',
  'input::placeholder': 'color: #626262; letter-spacing: 1px;',
  'input:focus': 'outline: none;',
};

export const cardNumberPlaceholder = '–––– –––– –––– ––––';
export const expirationPlaceholder = '--/--';
export const cvcPlaceholder = '---';

export const getPlaceHolders = (
  formatMessage: (
    descriptor: import('react-intl').MessageDescriptor,
    values?: Record<string, MessageFormatPrimitiveValue>
  ) => string,
  placeHolderPrefix: string
) => ({
  holdername: formatMessage({ id: `${placeHolderPrefix}.holdername` }),
  cardnumber: cardNumberPlaceholder,
  expiration: expirationPlaceholder,
  cvc: cvcPlaceholder,
});
